import type { PluginConfigField } from '../../lib/types';
import { isStepAligned } from '../../lib/pluginNumber';

export const numberDivisor = (field: PluginConfigField): number => field.display?.divisor ?? 1;
export const displayNumber = (field: PluginConfigField, canonical: number): number => canonical / numberDivisor(field);
export const displayBound = (value: number | undefined, divisor: number): number | undefined => value === undefined ? undefined : value / divisor;
export const displayPlaceholder = (field: PluginConfigField): string | undefined => {
  if (field.placeholder === undefined || numberDivisor(field) === 1) return field.placeholder;
  const value = Number(field.placeholder);
  return Number.isFinite(value) ? String(displayNumber(field, value)) : field.placeholder;
};
export const decimalPlaces = (value: number): number => {
  const [mantissa, exponentText] = String(value).toLowerCase().split('e');
  const fraction = mantissa?.split('.')[1]?.length ?? 0;
  return Math.max(0, fraction - Number(exponentText ?? 0));
};
export const sliderCurrentValid = (field: PluginConfigField, canonical: number | undefined): canonical is number => (
  canonical !== undefined
  && canonical >= field.min!
  && canonical <= field.max!
  && isStepAligned(canonical, field.min!, field.step!)
);
export const sliderCanonicalValue = (field: PluginConfigField, displayed: number): number => {
  const divisor = numberDivisor(field);
  const min = field.min!;
  const max = field.max!;
  const step = field.step!;
  const displayedMin = min / divisor;
  const displayedStep = step / divisor;
  const stepIndex = Math.round((displayed - displayedMin) / displayedStep);
  const nearest = min + stepIndex * step;
  const precision = Math.max(decimalPlaces(min), decimalPlaces(step));
  return Math.min(max, Math.max(min, Number(nearest.toFixed(precision))));
};
